import React from "react";

const DashboardStats = ({ dashboardData }) => {
  return (
    <>
      <div className="dashboardStats ">
        <div className="dashboardStat green">
          <h4 className="number">{dashboardData?.counts?.totalUsers}</h4>
          <p className="desc"> Total Users </p>
        </div>
        <div className="dashboardStat red">
          <h4 className="number">{dashboardData?.counts?.todaysUsers}</h4>
          <p className="desc"> Today Users </p>
        </div>
        <div className="dashboardStat blue">
          <h4 className="number">{dashboardData?.counts?.todaysJobs}</h4>
          <p className="desc"> Today Jobs </p>
        </div>
        <div className="dashboardStat green">
          <h4 className="number">{dashboardData?.counts?.totalJobs}</h4>
          <p className="desc"> Total Jobs </p>
        </div>
        <div className="dashboardStat red">
          <h4 className="number">{dashboardData?.counts?.todaysCandidates}</h4>
          <p className="desc"> Today Candidates </p>
        </div>
        <div className="dashboardStat blue">
          <h4 className="number">{dashboardData?.counts?.totalCandidates}</h4>
          <p className="desc"> Total Candidates </p>
        </div>
      </div>
    </>
  );
};

export default DashboardStats;
